export const ACCOUNT_TYPE_OPTIONS = {
  PERSONAL_SAVINGS: "Personal savings",
  PERSONAL_CHECKING: "Personal checking",
  BUSINESS_SAVINGS: "Business savings",
  BUSINESS_CHECKING: "Business checking",
};
